export var matchDisplayName = function matchDisplayName(childRef, displayName) {
  return childRef && childRef.type.render && childRef.type.render.displayName && childRef.type.render.displayName.indexOf(displayName) > -1 || childRef && childRef.type.displayName && childRef.type.displayName.indexOf(displayName) > -1;
};